import { categories } from "@/mocks/gossip";

type Props = {
  onSelect: (categoryName: string) => void;
};

const toneStyles = [
  { bubble: "bg-primary-100 text-primary-600", chip: "bg-primary-50 text-primary-700" },
  { bubble: "bg-accent-100 text-accent-700", chip: "bg-accent-50 text-accent-800" },
  { bubble: "bg-secondary-100 text-secondary-700", chip: "bg-secondary-50 text-secondary-800" },
];

export default function CategoryGrid({ onSelect }: Props) {
  return (
    <section id="categories" className="bg-background-100 py-16 md:py-24">
      <div className="shell">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-medium uppercase tracking-[0.2em] text-secondary-600">Categories</span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">瓜料分类</h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            按圈层划分你的吃瓜路线，点一下分类，下方爆料流会立刻筛选出对应内容。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat, index) => {
            const tone = toneStyles[index % toneStyles.length];
            return (
              <a
                key={cat.id}
                href="#feed"
                onClick={() => onSelect(cat.name)}
                className="group flex cursor-pointer items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
              >
                <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-md text-2xl ${tone.bubble}`}>
                  <i className={cat.icon} aria-hidden="true" />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="flex items-center gap-2">
                    <strong className="font-heading text-lg text-foreground-950 group-hover:text-primary-700">{cat.name}</strong>
                    <em className={`not-italic rounded-sm px-1.5 py-0.5 text-[11px] ${tone.chip}`}>{cat.count} 条</em>
                  </span>
                  <span className="mt-2 block text-sm leading-6 text-foreground-600">{cat.desc}</span>
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}